import { render, staticRenderFns } from "./FmDialogDemo.vue?vue&type=template&id=6f4a559c&scoped=true&"
import script from "./FmDialogDemo.vue?vue&type=script&lang=js&"
export * from "./FmDialogDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4a559c",
  null
  
)

export default component.exports